// Module-wise Page Actions Configuration
// This defines all available permissions across the system
// Auto-generated based on actual pages in the application

const actions = [
  // GENERAL MODULE
  {
    "module": "GENERAL",
    "page": "Dashboard",
    "actions": ["VIEW"]
  },
  {
    "module": "GENERAL",
    "page": "Profile",
    "actions": ["VIEW", "EDIT"]
  },
  {
    "module": "GENERAL",
    "page": "Security",
    "actions": ["VIEW", "EDIT"]
  },

  // SETTINGS MODULE
  {
    "module": "SETTINGS",
    "page": "General",
    "actions": ["VIEW", "EDIT"]
  },

  // COMMUNICATION MODULE
  {
    "module": "COMMUNICATION",
    "page": "Notifications",
    "actions": ["VIEW", "EDIT"]
  },

  // ADMIN MODULE
  {
    "module": "ADMIN",
    "page": "Users",
    "actions": ["VIEW", "CREATE", "EDIT", "DELETE", "PERMISSIONS"]
  },
  {
    "module": "SETTINGS",
    "page": "SMTPSMS",
    "actions": ["VIEW", "CREATE", "EDIT", "DELETE", "TOGGLESTATUS"]
  },
  {
    "module": "SETTINGS",
    "page": "Gateway",
    "actions": ["VIEW", "CREATE", "EDIT", "DELETE", "TOGGLESTATUS"]
  },
  {
    "module": "SETTINGS",
    "page": "Coupons",
    "actions": ["VIEW", "CREATE", "EDIT", "DELETE", "TOGGLESTATUS"]
  },
  {
    "module": "SETTINGS",
    "page": "Taxes",
    "actions": ["VIEW", "CREATE", "EDIT", "DELETE", "TOGGLESTATUS"]
  },
  {
    "module": "SETTINGS",
    "page": "AdditionalCharges",
    "actions": ["VIEW", "CREATE", "EDIT", "DELETE", "TOGGLESTATUS"]
  },
  {
    "module": "SETTINGS",
    "page": "NoticeBoard",
    "actions": ["VIEW", "CREATE", "EDIT", "DELETE", "TOGGLESTATUS"]
  },

  // EXAM MODULE
  {
    "module": "EXAM",
    "page": "AdminExams",
    "actions": ["VIEW", "CREATE", "EDIT", "DELETE", "TOGGLESTATUS"]
  },
  {
    "module": "EXAM",
    "page": "ExamReceipt",
    "actions": ["VIEW"]
  },

  // REWARDS MODULE
  {
    "module": "REWARDS",
    "page": "RewardSetup",
    "actions": ["VIEW", "CREATE", "EDIT", "DELETE", "TOGGLESTATUS"]
  },
  {
    "module": "EXAM",
    "page": "Questions",
    "actions": ["VIEW", "CREATE", "EDIT", "DELETE", "TOGGLESTATUS"]
  },
  {
    "module": "REWARDS",
    "page": "RewardAllotment",
    "actions": ["VIEW", "CREATE", "EDIT", "DELETE", "SENDEMAIL"]
  },

  {
    "module": "EXAM",
    "page": "Results",
    "actions": ["VIEW", "CREATE", "EDIT", "DELETE", "TOGGLESTATUS"]
  },

//   // ACADEMIC MODULE
//   {
//     "module": "EXAM",
//     "page": "Enrollments",
//     "actions": ["VIEW", "EDIT", "DELETE"]
//   },
  {
    "module": "EXAM",
    "page": "Participants",
    "actions": ["VIEW", "CREATE", "EDIT", "DELETE", "TOGGLESTATUS", "SENDEMAIL"]
  },
  {
    "module": "SETTINGS",
    "page": "Customers",
    "actions": ["VIEW", "CREATE", "EDIT", "DELETE", "EXPORT", "PERMISSIONS"]
  },

  // FINANCE MODULE
  {
    "module": "FINANCE",
    "page": "WalletEarnings",
    "actions": ["VIEW", "CREATE", "EDIT", "DELETE", "TOGGLESTATUS"]
  },
  // {
  //   "module": "FINANCE",
  //   "page": "WalletWithdrawals",
  //   "actions": ["VIEW", "CREATE", "EDIT", "DELETE", "APPROVE", "REJECT", "TOGGLESTATUS"]
  // },
  {
    "module": "FINANCE",
    "page": "WalletEarningReceipt",
    "actions": ["VIEW"]
  },
  // {
  //   "module": "FINANCE",
  //   "page": "WithdrawalReceipt",
  //   "actions": ["VIEW"]
  // },
  {
    "module": "BOOKS",
    "page": "Books",
    "actions": ["VIEW", "CREATE", "EDIT", "DELETE"]
  },
  {
    "module": "QUERIES",
    "page": "Queries",
    "actions": ["VIEW", "CREATE", "EDIT", "DELETE"]
  },
  {
    "module": "REFERRALS",
    "page": "Referrals",
    "actions": ["VIEW", "CREATE", "EDIT", "DELETE", "TOGGLESTATUS", "SENDSMS"]
  },
  {
    "module": "SUPPORTTICKETS",
    "page": "SupportTickets",
    "actions": ["VIEW", "CREATE", "EDIT", "DELETE", "TOGGLESTATUS", "SENDMAIL"]
  },






//   {
//     "module": "ADMIN",
//     "page": "RoleManagement",
//     "actions": ["VIEW", "CREATE", "EDIT", "DELETE"]
//   },

//   {
//     "module": "EXAM",
//     "page": "Exams",
//     "actions": ["VIEW"]
//   },
//   {
//     "module": "EXAM",
//     "page": "ExamAttend",
//     "actions": ["VIEW"]
//   },
//   {
//     "module": "EXAM",
//     "page": "ExamResult",
//     "actions": ["VIEW"]
//   },
//   {
//     "module": "EXAM",
//     "page": "CompleteExam",
//     "actions": ["VIEW"]
//   },
//   {
//     "module": "EXAM",
//     "page": "LiveMonitoring",
//     "actions": ["VIEW", "MONITOR"]
//   },

  // FINANCE MODULE
//   {
//     "module": "FINANCE",
//     "page": "Billing",
//     "actions": ["VIEW"]
//   },
//   {
//     "module": "FINANCE",
//     "page": "Transaction",
//     "actions": ["VIEW", "CREATE", "EDIT", "DELETE"]
//   },
//   {
//     "module": "FINANCE",
//     "page": "PaymentManagement",
//     "actions": ["VIEW", "ANALYTICS", "REPORTS"]
//   },

];

export default actions;
